import React from 'react';
import HandbookLayout from './components/HandbookLayout';
import krisscoData from './krissco.json';

const KrisscoHandbook: React.FC = () => {
  return <HandbookLayout data={krisscoData as any} />;
};

export default KrisscoHandbook;
